import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '#app/hooks/useAppStore';
import { handleDeepLink, isMobileDevice } from '#app/helpers/deepLinkHandler';
import useAppMetricaLinks from '../../../pages/MainPage/hooks/useAppMetricaLinks';
import {
  HeaderContainer,
  HeaderLogo,
  HeaderMenu,
  HeaderOther,
  HeaderPersonal,
  HeaderWrapper,
  Wrap,
} from './styles';
import LogoWithTrademark from '#app/components/LogoWithTrademark';
import PartnerLogoLink from '#app/components/PartnerLogoLink';
import { getUserAccounts } from '#app/actions/account';
import { handleClient, handleCurrency } from '../../../actions/interface';
import { startScenario } from '../../../actions/scenario';
import {
  handleCloseModal,
  handleForgotModal,
  handleLoginModal,
  handleRegisterModal,
  handleSubscribeModal,
  logout,
} from '../../../actions/auth';
import withRouter from '../../../components/WithRouter/withRouter';
import HeaderModals from '#app/interface/landing/header/components/HeaderModals';
import { routes } from '#app/constants/routes';

const blackswanLogo = require('./images/blackswan-w.svg');

const Header = (props) => {
  const { navigate } = props;
  const dispatch = useAppDispatch();
  const auth = useAppSelector((s) => s.auth?.auth);
  const data = useAppSelector((s) => s.auth?.data);
  const client = useAppSelector((s) => s.interfaceComponents?.client);
  const clients = useAppSelector((s) => s.interfaceComponents?.clients);
  const currency = useAppSelector((s) => s.interfaceComponents?.currency);
  const currencies = useAppSelector((s) => s.interfaceComponents?.currencies);
  const showLoginModal = useAppSelector((s) => s.auth?.showLoginModal);
  const showRegisterModal = useAppSelector((s) => s.auth?.showRegisterModal);
  const showForgotModal = useAppSelector((s) => s.auth?.showForgotModal);
  const showSubscribeModal = useAppSelector((s) => s.auth?.showSubscribeModal);
  const i18n = useAppSelector((s) => s.i18n);
  const headerProps = {
    ...props,
    auth,
    data,
    client,
    clients,
    currency,
    currencies,
    showLoginModal,
    showRegisterModal,
    showForgotModal,
    showSubscribeModal,
    i18n,
    handleClient: useCallback((...args) => dispatch(handleClient(...args)), [dispatch]),
    handleCurrency: useCallback((...args) => dispatch(handleCurrency(...args)), [dispatch]),
    getUserAccounts: useCallback(() => dispatch(getUserAccounts()), [dispatch]),
    logout: useCallback((...args) => dispatch(logout(...args)), [dispatch]),
    startScenario: useCallback((...args) => dispatch(startScenario(...args)), [dispatch]),
    handleLoginModal: useCallback(() => dispatch(handleLoginModal()), [dispatch]),
    handleCloseModal: useCallback(() => dispatch(handleCloseModal()), [dispatch]),
    handleRegisterModal: useCallback(() => dispatch(handleRegisterModal()), [dispatch]),
    handleForgotModal: useCallback(() => dispatch(handleForgotModal()), [dispatch]),
    handleSubscribeModal: useCallback(() => dispatch(handleSubscribeModal()), [dispatch]),
  };
  const [isScrolled, setIsScrolled] = useState(false);
  const { appStoreUrl } = useAppMetricaLinks();

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setIsScrolled(true);
    } else if (window.pageYOffset === 0) {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <HeaderWrapper>
      <HeaderContainer className={isScrolled ? 'scrolled' : ''}>
        <Wrap>
          <HeaderLogo>
            <LogoWithTrademark variant="default" />
          </HeaderLogo>
          <HeaderMenu style={isScrolled ? { transform: 'translate3d(0,-50%,0)', opacity: 1 } : {}}>
            <div>
              {/*<Link to="/#functions">Что умеет</Link>*/}
              {/*<Link to="/#prices">Сколько стоит</Link>*/}
              {/*<Link to="/#buy">Купить</Link>*/}
            </div>
          </HeaderMenu>
        </Wrap>
        <HeaderPersonal>
          <a
            id={'login-button'}
            className="style2"
            onClick={(e) => {
              e.preventDefault();
              // console.log('[Header] Login button clicked', { auth, appStoreUrl });

              if (auth) {
                // console.log('[Header] User is authenticated, navigating to cabinet');
                navigate(routes.CABINET);
              } else {
                if (isMobileDevice()) {
                  // console.log('[Header] Mobile device detected, attempting deep link');
                  const handled = handleDeepLink(appStoreUrl);
                  if (!handled) {
                    // console.log('[Header] Deep link not handled, opening login modal');
                    headerProps.handleLoginModal();
                  }
                } else {
                  // console.log('[Header] Desktop device, opening login modal');
                  headerProps.handleLoginModal();
                }
              }
            }}
          >
            {i18n.auth?.enter}
          </a>
        </HeaderPersonal>
        <HeaderOther>
          <PartnerLogoLink
            href="https://blackswan.finance"
            logo={blackswanLogo}
            brand="blackswan"
            comment={i18n?.auth?.crm}
            commentStyle={isScrolled ? { display: 'none' } : {}}
          />
        </HeaderOther>
      </HeaderContainer>
      <HeaderModals {...headerProps} />
    </HeaderWrapper>
  );
};

export default withRouter(Header);
